'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { RadioGroup } from '@headlessui/react'

import { updateSearchParams, getSearchParams, removeSearchParam } from "@utils";
import { sortTypes } from '@constants';
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai'
import tailwindConfig from '@tailwind.config'

const SortFilter = ({ title, dictionary }) => {
    const router = useRouter();
    let [sort, setSort] = useState('datedesc')
    let [addChecked, setAddChecked] = useState(sortTypes[0].value)


    const handleUpdateParams = (e) => {
        let newPathName
        if (e.value == 0) {
            newPathName = removeSearchParam(title);
        } else {
            newPathName = updateSearchParams(title, e.value);
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        const sortValue = getSearchParams('sort')
        setAddChecked(sortValue)
        const newValue = sortTypes.find(obj => obj.value === addChecked);

        if (newValue != undefined) {
            setSort(newValue)
        } else {
            setSort(sortTypes[0])
        }

    }, [handleUpdateParams])

    return (
        <div className="w-full mt-1">
            <span className='text-maincolor text-xl'>{dictionary.orderBy}:</span>
            <div className="w-full">
                <RadioGroup value={sort} onChange={(value) => {
                    setSort(value)
                    handleUpdateParams(value)
                }}
                    className='w-full mt-2 flex flex-row rounded-lg shadow-md border-[1px] border-forth overflow-hidden'
                >
                    <RadioGroup.Option
                        key={sortTypes[0].value}
                        value={sortTypes[0]}
                        checked={sortTypes[0] === sort}
                        className={({ active, checked }) =>
                            `${active
                                ? ''
                                : ''
                            }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                            }
                                    w-1/3 relative flex cursor-pointer rounded-l-lg shadow-md focus:outline-none`
                        }
                    >
                        {({ active, checked }) => (
                            <>
                                <div className="flex w-full items-center justify-center">
                                    <div className="flex items-center">
                                        <div className="text-sm text-center">
                                            <RadioGroup.Label
                                                as="p"
                                                className={`font-medium w-full  ${checked ? 'text-light' : 'text-maincolor'
                                                    }`}
                                            >
                                                {dictionary.newest}
                                            </RadioGroup.Label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </RadioGroup.Option>
                    <RadioGroup.Option
                        key={sortTypes[1].value}
                        value={sortTypes[1]}
                        checked={sortTypes[1] === sort}
                        className={({ active, checked }) =>
                            `${active
                                ? ''
                                : ''
                            }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                            }
                                    w-1/3 relative flex cursor-pointer px-2 py-2 shadow-md focus:outline-none`
                        }
                    >
                        {({ active, checked }) => (
                            <>
                                <div className="flex w-full items-center justify-center">
                                    <div className="flex items-center">
                                        <div className="text-sm text-center">
                                            <RadioGroup.Label
                                                as="p"
                                                className={`font-medium w-full flex flex-row items-center  ${checked ? 'text-light' : 'text-maincolor'
                                                    }`}
                                            >
                                                <span className='mr-1'>{dictionary.price}</span>
                                                <AiOutlineArrowUp
                                                    color={checked ? tailwindConfig.theme.extend.colors.light : tailwindConfig.theme.extend.colors.secondary}
                                                />
                                            </RadioGroup.Label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </RadioGroup.Option>
                    <RadioGroup.Option
                        key={sortTypes[2].value}
                        value={sortTypes[2]}
                        checked={sortTypes[2] === sort}
                        className={({ active, checked }) =>
                            `${active
                                ? ''
                                : ''
                            }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                            }
                                    w-1/3 relative flex cursor-pointer rounded-r-lg px-2 py-2 shadow-md focus:outline-none`
                        }
                    >
                        {({ active, checked }) => (
                            <>
                                <div className="flex w-full items-center justify-center">
                                    <div className="flex items-center">
                                        <div className="text-sm text-center">
                                            <RadioGroup.Label
                                                as="p"
                                                className={`font-medium w-full flex flex-row items-center ${checked ? 'text-light' : 'text-maincolor'
                                                    }`}
                                            >
                                                <span className='mr-1'>{dictionary.price}</span>
                                                <AiOutlineArrowDown
                                                    color={checked ? tailwindConfig.theme.extend.colors.light : tailwindConfig.theme.extend.colors.secondary}
                                                />
                                            </RadioGroup.Label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </RadioGroup.Option>
                </RadioGroup>
            </div>
        </div>
    )
}

export default SortFilter